import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import Form, { Conditional, Radio, RegexValidator, RequiredValidator, TextField, Actions } from '../../Components/Form';

const ChangeType = () => {
    const {website, changeType} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Website type" />
        <Page>
            {website && <Inner {...{website, changeType}} />}
        </Page>
    </>
}

const Inner = ({website, changeType}) => {
    const data = {
        type: website.type,
        subdomain: website.soapySubdomain,
        domain: website.domain,
    }
    return <Form data={data} onSubmit={changeType} goBackOnSubmit>
        <div className="prose prose-sm mb-4">
            <p>getSoapy offers a free basic website with everything you need built right in.</p>

            <p>You can also bring the benefits of getSoapy to any other website.</p>

            <p>Don't worry, you can change your mind later.</p>
        </div>

        <Radio name="type" label="Website type" layout="List" options={[
            {value: 'getsoapy', label: 'Free getSoapy website'},
            {value: 'thirdparty', label: 'Custom website'},
            {value: 'none', label: 'No website'},
        ]} />

        <Conditional condition={data => data.type === 'getsoapy'}>
            <TextField name="subdomain"
                label="Subdomain"
                prefix="https://"
                suffix=".getsoapy.com"
                validators={[
                    RequiredValidator,
                    RegexValidator(/^[a-z][-a-z]{1,50}[a-z]$/, 'Subdomain must only contain lowercase letters, numbers and hyphens'),
                ]}
            />
        </Conditional>

        <Conditional condition={data => data.type === 'thirdparty'}>
            <TextField name="domain"
                label="Domain"
                prefix="https://"
                validators={[
                    RequiredValidator,
                    RegexValidator(/^[a-z0-9][.a-z0-9-]{0,61}[a-z0-9]\.[a-z]{2,}$/i, 'Domain must be a valid domain name'),
                ]}
            />
        </Conditional>

        <Conditional condition={data => data.type === 'none'}>
            <div className="prose prose-sm">
                <p>If you'd rather not have a website, that's ok too.</p>

                <p>You can use the getSoapy Quote, Pay, and Customer Portal widgets on the getSoapy website.</p>
            </div>
        </Conditional>

        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default ChangeType;
